import React, { Component, Fragment } from "react";
import "./login.css";
import user from "./img/user.png";
import axios from "axios";
import swal from "sweetalert";
import { setToken, getToken } from "../../api/token";
import { siteURL, jwtPart } from "../../utils/constants";


const apiURLCon = `${siteURL}${jwtPart}`;


export default class login extends Component {
  state = {
    form: {
      username: "",
      password: "",
    },
  };

  handleChange = async (e) => {
    await this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  paginaCliente = async () =>{
    window.location.href = "../FlipbookCliente";
  }


  iniciarSesion = async () => {
    let qs = require("qs");
    let data = qs.stringify({
      username: this.state.form.username,
      password: this.state.form.password,
    });
    var config = {
      method: "post",
      url: apiURLCon,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: data,
    };
 //   console.log(this.state.form.username)
 //   console.log(this.state.form.password)
    axios(config)
      .then(function (response) {
      //  console.log(response)
        return response.data
       
      })
      .then(response=>{
    
          if(response.token){
            setToken(response.token);
            window.location.href = "../Flipbook";
         }else{
               swal({
                title: "Error",
                text: "Error al iniciar sesión",
                icon:"error",
                button:"Aceptar",
                timer:"2200"
               });  


            }
          

         
      })
      .catch(function (error) {
        console.log(error);
        swal({
          title: "Error",
          text: "Contraseña Incorrecta",
          icon:"error",
          button:"Aceptar",
          timer:"2200"
         });  
      });
  };

  componentDidMount(){
      /* if(cookies.get('id')){
        window.location.href = "../Flipbook";
      }*/
      //hasExpiredToken();
      const token = getToken();
      if(token){
        window.location.href = "../Flipbook";
      /* console.log(jwtDecode(token).data.user.id);
       console.log('existe el token');*/
      }
  }

  render() {
    return (
      <Fragment>
        <div className="wrapper fadeInDown">
          <div id="formContent">
            <div className="fadeIn first">
              <img src={user} id="icon" /> Iniciar Sesión
            </div>

            <input
              type="text"
              id="login"
              className="fadeIn second"
              name="username"
              placeholder="Código"
              onChange={this.handleChange}
            />
            <input
              type="password"
              id="password"
              className="fadeIn third"
              name="password"
              placeholder="Contraseña"
              onChange={this.handleChange}
            />
            <input
              type="button"
              className="btn btn-primary"
              value="Iniciar Sesión"
              onClick={() => this.iniciarSesion()}
            />

            <div id="formFooter">
              <a className="underlineHover" href="https://marykay.com.gt/account/password"
               target="_blank" rel="noreferrer">
                Olvide mi contraseña
              </a>
              <br />
              <button 
               className="btn btn-primary"
              onClick={()=>this.paginaCliente()}>
                  Quiero hacer un pedido a mi consultora de Belleza
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
